"use client";

import { forwardRef, type ComponentRef, type ElementType } from "react";

import { Icon, type IconProps } from "@chakra-ui/react";
import {
  FiArrowDown,
  FiArrowLeft,
  FiArrowRight,
  FiCheck,
  FiChevronDown,
  FiInfo,
  FiMenu,
  FiSearch,
  FiX
} from "react-icons/fi";
import { IoCheckmarkCircleOutline } from "react-icons/io5";

function createChakraIcon(icon: ElementType, displayName: string) {
  const Component = forwardRef<ComponentRef<"svg">, IconProps>((props, ref) => (
    <Icon ref={ref} as={icon} {...props} />
  ));
  Component.displayName = displayName;
  return Component;
}

export const SearchIcon = createChakraIcon(FiSearch, "SearchIcon");
export const CheckIcon = createChakraIcon(FiCheck, "CheckIcon");
export const ArrowLeftIcon = createChakraIcon(FiArrowLeft, "ArrowLeftIcon");
export const ArrowRightIcon = createChakraIcon(FiArrowRight, "ArrowRightIcon");
export const ArrowDownIcon = createChakraIcon(FiArrowDown, "ArrowDownIcon");
export const CheckCircleIcon = createChakraIcon(
  IoCheckmarkCircleOutline,
  "CheckCircleIcon"
);
export const InfoOutlineIcon = createChakraIcon(FiInfo, "InfoOutlineIcon");
export const CloseIcon = createChakraIcon(FiX, "CloseIcon");
export const HamburgerIcon = createChakraIcon(FiMenu, "HamburgerIcon");
export const ChevronDownIcon = createChakraIcon(
  FiChevronDown,
  "ChevronDownIcon"
);
